import React from "react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="text-center mt-12 bg-black-100 text-orange min-h-[50vh]">
      <h1 className="text-6xl font-bold">404</h1>
      <h2 className="text-4xl mt-4">{t("pageNotFound")}</h2>
      <p className="text-lg mt-2">{t("sorryPageNotExist")}</p>
      <a href="/" className="hover:underline mt-4 block text-orange">
        {t("goToHome")}
      </a>
    </div>
  );
};

export default NotFound;
